var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwitchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.31669 2.83334C3.85002 2.83334 3.51669 3.21667 3.51669 3.68334C3.51669 4.14167 3.88335 4.51667 4.35002 4.51667H9.00002L7.91669 5.59167C7.58335 5.91667 7.58335 6.44167 7.91669 6.76667C8.24169 7.09167 8.76669 7.09167 9.09169 6.76667L11.5917 4.26667C11.7417 4.10834 11.8334 3.89167 11.8334 3.675C11.8334 3.45 11.7417 3.24167 11.5834 3.08334L9.08335 0.583336C8.75002 0.250003 8.22502 0.250003 7.90002 0.583336C7.56669 0.908336 7.56669 1.43334 7.90002 1.75834L8.97502 2.83334H4.31669Z",
    fill: "#7A8797"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68335 11.1667C8.15002 11.1667 8.48335 10.7833 8.48335 10.3167C8.48335 9.85834 8.11669 9.48334 7.65002 9.48334H3.00002L4.08335 8.40834C4.41669 8.08334 4.41669 7.55834 4.08335 7.23334C3.75835 6.90834 3.23335 6.90834 2.90835 7.23334L0.408353 9.73334C0.258353 9.89167 0.166687 10.1083 0.166687 10.325C0.166687 10.55 0.258353 10.7583 0.416686 10.9167L2.91669 13.4167C3.25002 13.75 3.77502 13.75 4.10002 13.4167C4.43335 13.0917 4.43335 12.5667 4.10002 12.2417L3.02502 11.1667L7.68335 11.1667Z",
    fill: "#7A8797"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchIcon);
export default __webpack_public_path__ + "static/media/SwitchIcon.3048772d.svg";
export { ForwardRef as ReactComponent };